/**
 * Application configuration that reads from environment variables.
 * All environment variables must be prefixed with REACT_APP_ to be accessible in React.
 * Make sure to set all required environment variables before building/running the application.
 */
let runtimeConfig = null;

const loadConfig = async () => {
  if (!runtimeConfig) {
    try {
      const response = await fetch('/config.json');
      runtimeConfig = await response.json();
    } catch (error) {
      console.warn('Failed to load runtime config, using environment variables');
      runtimeConfig = {};
    }
  }
  return runtimeConfig;
};

const Config = {
    FHIRAPIUrl: process.env.REACT_APP_FHIR_API_URL,
    oAuth: {
        clientId: process.env.REACT_APP_OAUTH_CLIENT_ID,
        providerDirectoryClientId: process.env.REACT_APP_OAUTH_PROVIDER_DIRECTORY_CLIENT_ID,
        providerDirectoryClientSecret: process.env.REACT_APP_OAUTH_PROVIDER_DIRECTORY_CLIENT_SECRET,
        identityServerUrl: process.env.REACT_APP_OAUTH_IDENTITY_SERVER_URL,
        redirectUri: process.env.REACT_APP_OAUTH_REDIRECT_URI,
        scopes: process.env.REACT_APP_OAUTH_SCOPES ? process.env.REACT_APP_OAUTH_SCOPES.split(',') : []
    },
    registrationRoleId: process.env.REACT_APP_REGISTRATION_ROLE_ID,
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    csrfToken: process.env.REACT_APP_CSRF_TOKEN,
    loadRuntimeConfig: loadConfig
};

// RC
    // FHIRAPIUrl: 'https://rcaccares.acgov.org/api/',
    // oAuth: {
    //    clientId: 'cgFHIR_App',
    //    providerDirectoryClientId: 'FHIR_ProviderDirectory',
    //    providerDirectoryClientSecret: 'KrassonsCG2022',
    //    identityServerUrl: 'https://rcaccares.acgov.org/identity',
    //    redirectUri: 'https://rcaccares.acgov.org/Login',
    //    scopes: ['cgFhirApi.read', 'cgFhirApi.write']
    //},
    //registrationRoleId: '1dd7dab0-3072-4dee-8dcf-4f058ffc8735',
    //recaptchaSiteKey: '6Ldm37MrAAAAALfbL0oXu_JrWVsnfIqiUscEhn2X'

export default Config;
